import React from 'react';

import { Col, Row } from 'modules/bootstrap/components';
import {
  MyContacts,
  MyContactsReferralSection,
} from 'modules/myContacts/components';

function MyContactsPage() {
  return (
    <Row className="t-h-100">
      <Col
        md={{ span: 12 }}
        xl={{ span: 10, offset: 2 }}
        style={{ paddingRight: 0 }}
      >
        <Row className="t-m-0 t-p-0 t-mb-7 t-bg-alpha-100">
          <Col
            md={{ span: 12 }}
            xl={{ span: 7 }}
            className="card t-bg-beta-50 md:t-p-12 xs:t-px-8 xs:t-py-10"
          >
            <MyContacts />
          </Col>
          <Col md={{ span: 12 }} xl={{ span: 5 }} className="t-m-0 t-p-0">
            <MyContactsReferralSection />
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default MyContactsPage;
